/*
 * @Author: ezhizao 庄德政
 * @LastEditors: ezhizao 庄德政
 * @Description: 
 */
const routers = [{
  // 企业编辑
  path: '/company/list',
  name: 'company_list',
  component: () => import('./List.vue')
}, {
  // 企业变更申请记录
  path: '/company/form',
  name: 'company_form',
  component: () => import('./Form.vue')
}]
export default routers